'use client';

import Arrow from '@publicImages/svg/arrow-right.svg?icon';

import Button from '@/components/elements/Button';
import UIResource from '@/components/UIResource';

import styles from './BackToTopButton.module.scss';

const BackToTopButton = () => {
  const scrollToTop = () => {
    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    });
  };

  return (
    // TODO: Button has strange behavior if children > 1, need to be refactored.
    <Button className={styles.root} onClick={scrollToTop} variant="link">
      <>
        <UIResource id="Layout.backToTop" />
        <Arrow aria-hidden />
      </>
    </Button>
  );
};

export default BackToTopButton;
